<!-- =========================================================================================
				File Name: KnowledgeBase.vue
				Description: Knowledge Base Page
				----------------------------------------------------------------------------------------
				Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
						Author: Pixinvent
				Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="knowledge-base-page">
    <!-- JUMBOTRON -->
    <div class="knowledge-base-jumbotron">
      <div
        class="
          knowledge-base-jumbotron-content
          lg:p-20
          md:p-15
          sm:p-8
          p-8
          rounded-lg
          mb-base
        "
      >
        <h1 class="mb-1 font-bold text-white">{{ title }}</h1>
        <div v-if="showFilter">
          <p class="text-white mb-3">{{ desc }}</p>
          <!-- <vs-input icon-no-border placeholder="Search Topic or Keyword" v-model="searchQuery" icon-pack="feather" icon="icon-search" size="large" class="w-full mt-6" /> -->
          <vue-simple-suggest
            pattern="\w+"
            v-model="searchQuery"
            :list="getArticleList"
            :max-suggestions="5"
            :min-length="1"
            :debounce="200"
            :filter-by-query="false"
            :prevent-submit="true"
            :controls="{
              selectionUp: [38, 33],
              selectionDown: [40, 34],
              select: [13, 36],
              hideList: [27, 35],
            }"
            :mode="mode"
            :nullable-select="true"
            ref="suggestComponent"
            v-bind:placeholder="$t('action.searchAtt', [$t('attribute.article')])"
            value-attribute="title"
            display-attribute="title"
            class="mb-2"
            @select="onSuggestSelect"
          >
            <template slot="misc-item-above" slot-scope="{ suggestions, query }">
              <div class="misc-item">
                <span>{{ $t("action.searchingAtt", [query]) }}.</span>
              </div>

              <template v-if="suggestions.length > 0">
                <div class="misc-item">
                  <span>{{ suggestions.length }} {{ $t("attribute.result") }}</span>
                </div>
                <hr />
              </template>

              <div class="misc-item" v-else-if="!loading">
                <span>{{ $t("general.notFound", { msg: $t("attribute.article") }) }}</span>
              </div>
            </template>

            <div slot="suggestion-item" slot-scope="scope" :title="scope.suggestion.title">
              <p v-html="boldenSuggestion(scope)"></p>
            </div>

            <div class="misc-item" slot="misc-item-below" v-if="loading">
              <span>{{ $t("action.loading") }}...</span>
            </div>
          </vue-simple-suggest>
        </div>

        <div class="text-white" v-if="showHelpButton">
          <!-- <div class="mb-2 text-white">Click button below to start chat with us!</div> -->
          <vs-button @click="initiateLiveChat()">{{ $t("action.contactUs") }}</vs-button>
        </div>
      </div>
    </div>

    <template v-if="api_errors.length > 0">
      <div class="mb-2" v-for="error in api_errors" :key="error.message">
        <vs-alert color="danger" icon="new_releases">
          <span>{{ error }}</span>
        </vs-alert>
      </div>
    </template>
  </div>
</template>

<script>
import Crypto from "@/helper/crypto";
import ErrorHandler from "@/helper/error_handler";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";

export default {
  name: "help-center-filter",
  props: {
    title: {
      type: String,
      default: "Hello, how can we help?",
    },
    desc: {
      type: String,
      default: "Start typing your topic in search box or choose a category to find the help you need.",
    },
    showHelpButton: {
      type: Boolean,
      default: false,
    },
    showFilter: {
      type: Boolean,
      default: true,
    },
    groupId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      api_errors: [],
      searchQuery: "",
      mode: "input",
      loading: false,
      isAuth: false,
    };
  },
  components: {
    VueSimpleSuggest,
  },
  created() {
    this.isAuth = this.$store.getters.isLoggedIn;
  },
  methods: {
    getArticleList(val) {
      return new Promise((resolve, reject) => {
        let url = null;
        url = this.$endpoints.article;

        let params = {
          keyword: val,
          is_auth: this.isAuth,
        };
        if (this.groupId) {
          params.article_group_id = this.groupId;
        }

        this.$http
          .get(url, {
            params: params,
          })
          .then((res) => {
            resolve(res.data.data);
          })
          .catch((err) => {
            this.loading = false;
            reject(error);
          });
      });
    },
    onSuggestSelect(suggest) {
      if ("slug" in suggest) {
        let routeName = null;
        if (this.isAuth) {
          routeName = "customer-help-center-article";
        } else {
          routeName = "public-help-center-article";
        }

        let routeData = this.$router.push({
          name: routeName,
          params: {
            slug: suggest.slug,
            data: suggest,
          },
        });
      }
    },
    boldenSuggestion(scope) {
      if (!scope) return scope;
      const { suggestion, query } = scope;
      let result = this.$refs.suggestComponent.displayProperty(suggestion);
      if (!query) return result;
      const texts = query.split(/[\s-_/\\|.]/gm).filter((t) => !!t) || [""];
      if (result.length) {
        return result.replace(new RegExp("(.*?)(" + texts.join("|") + ")(.*?)", "gi"), "$1<b>$2</b>$3");
      }
    },
    initiateLiveChat() {
      window.open(this.$endpoints.public_livechat, "_blank");
    },
  },
};
</script>
